import { css } from '@emotion/core';
import { rgba, variables as vars, tokens } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font,
  global = vars.global;
var colors = tokens.colors;
export var popup = /*#__PURE__*/css("display:inline-block;position:absolute;padding-bottom:40px;border:1px solid ", colour.neutral100, ";pointer-events:auto;background-color:", colour.white, ";box-shadow:0 1px 8px 0 ", rgba(colour.black, 0.15), ";z-index:", global.layerFloating + 1, ";min-width:333px;min-height:330px;width:333px;width:100%;top:calc(100% + 15px);left:-113px;right:auto;&::after,&::before{bottom:100%;left:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;border-color:", rgba(colour.white, 0), ";}&::before{border-bottom-color:", colour.neutral200, ";border-width:10px;margin-left:-10px;top:-21px;}&::after{border-bottom-color:", colour.white, ";border-width:10px;margin-left:-10px;}");
export var message = /*#__PURE__*/css("text-align:left;color:", colour.neutral700, ";font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";margin:25px 20px;line-height:", font.baseLineHeight, ";margin-bottom:10px;");
export var hasText = {
  name: "260zpl",
  styles: "left:0;"
};
export var buttonGroup = {
  name: "tmvf25",
  styles: "text-align:center;margin:0 20px;margin-top:16px;display:flex;"
};
export var button = /*#__PURE__*/css("margin:auto;font-family:", font.bodyFontFamily, ";flex:1;padding:8px 0;outline:none;");
export var lightButton = {
  name: "lvyu5j",
  styles: "margin-right:10px;"
};
export var option = /*#__PURE__*/css("display:block;padding:15px 20px;background:none;border:0;outline:0;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";color:", colors.neutral.heavy.default, ";position:relative;width:100%;text-align:left;cursor:pointer;&:hover{background-color:", colour.neutral100, ";}");
export var selectedOptionIcon = /*#__PURE__*/css("position:absolute;top:10px;right:20px;color:", colors.neutral.heavy.default, ";");
export var alwaysCheck = {
  name: "s8vbhp",
  styles: "margin-left:20px;"
};
export var modalDialog = {
  name: "aj2zwd",
  styles: "background:rgba(0,0,0,0.4) !important;"
};